import { NgIf } from '@angular/common';
import { Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { GroundworksAuthLifecycleService } from '@groundworks/ngx-groundworks-auth';
import { ConfigService } from './config.service';
import { PostLoginService } from './services/post-login.service';
import { ProfileService } from './services/profile.service';

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, RouterLink, NgIf],
  templateUrl: './shell.component.html',
  standalone: true
})
export class ShellComponent implements OnInit {
  title = 'home-page-client';
  whoami = '';
  selectedBranch: string | null | undefined = '';
  defaultBranchSet = true;
  production = false;
  env = '';

  private readonly profileService = inject(ProfileService);
  private readonly authLifecycle = inject(GroundworksAuthLifecycleService);
  private readonly configService = inject(ConfigService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly postLoginService = inject(PostLoginService);

  readonly postLoginAlert = computed(() => {
    switch (this.postLoginService.failure()) {
      case 'profile':
        return "We couldn't load your profile, so your name, apps and default branch may be missing.";
      case 'roles':
        return "We couldn't load your permissions, so some apps may be missing.";
      default:
        return null;
    }
  });

  constructor() {
    this.production = this.configService.production;
    this.env = this.configService.env;
  }

  ngOnInit(): void {
    this.profileService.whoami$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(name => {
      this.whoami = name;
    });
  }

  async logout(): Promise<void> {
    try {
      await this.authLifecycle.logout();
    } catch (error) {
      console.error('Logout redirect failed:', error);
    }
  }

  async signInAgain(): Promise<void> {
    try {
      await this.profileService.signInAgain();
    } catch (error) {
      console.error('Sign-in redirect failed:', error);
    }
  }

  get isNotRoot(): boolean {
    return this.router.url !== '/';
  }
}
